export default "__VITE_ASSET__b75a45fe__"